module.exports = __webpack_public_path__ + "img/1c8c5d016287d988e258957d600229f6.png";